import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import { DataGrid, GridColDef, GridCellParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { RootState, useAppDispatch, useAppSelector } from "../../../store";
import PaginationControl from "../pagination/Pagination";
import Swal from "sweetalert2";

const KeyUsageLogTable = ({
  data,
  params,
  setParams,
}: any) => {
  // REGION: INIT VARIABLES


  // REGION: INIT COLUMNS
  const columns: GridColDef[] = [
    {
      field: "keyName",
      headerName: "Key Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "certCN",
      headerName: "Certificate Common Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "historyDate",
      headerName: "History Date",
      flex: 1,
      minWidth: 200,
    },
  ];

  // REGION: INIT ROWS
  console.log(' wkwkw ===> ', data?.data?.data)
  const dataRow = data?.data?.data !== undefined ? data?.data?.data : [];
  const totalConfig = data?.data !== undefined ? data?.data?.total_records : 0;
  const rows = dataRow?.map((row: any, index: any) => ({
    id: index,
    keyName: row.dsg_key_name,
    certCN: row.dsg_certificate_common_name,
    historyDate: row.dsg_key_sign_history_date,
  }));

  // REGION: RETURN TSX
  return (
    <>
      <Box sx={{ height: "650px" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnMenu
          hideFooter
          disableColumnSelector
          disableDensitySelector
          disableSelectionOnClick
          getRowHeight={() => "auto"}
          sx={{
            '& .MuiDataGrid-cell': {
              padding: '16px',  // Adjust the padding as needed
            },
          }}
        />
      </Box>
      <PaginationControl
        params={params}
        setParams={setParams}
        total={totalConfig}
      />
    </>
  );
};

export default KeyUsageLogTable;
